/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomSysOrganizationsLocationsSelect/view.blocks to change it.
import Locations from './Locations/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomSysOrganizationsLocationsSelect({
  children,
  viewPath = "/DesignSystem/DataVaxiomSysOrganizationsLocationsSelect"
  
}) {
  return (<React.Fragment
>
<Locations
  viewPath={`${viewPath}/Locations`}
/>
{children}
</React.Fragment>)
}